import config from '../../config/config';

import getRequest from './base/get';

export default {
  /**
   * Fetch transaction by Id
   * @returns
   */
  fetchTransactionById: (id: string) => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/consumer-transaction-info/${id}`,
    );
  },
};
